export enum OrderoutEnums {
  PICKUP = 'PICKUP',
  UBEREATS = 'ubereats',
  DOORDASH = 'doordash',
  PAYMENT_STATUS_PAID = 'PAID',
  ORDER_ACCEPTED = 'ACCEPTED',
  ORDER_REJECTED = 'REJECTED',
}

export enum OrderoutEventEnum {
  RECEIVED = 'received',
  CANCELLED = 'cancelled',
}

export interface OrderoutRestaurantType {
  id: number;
  api_created_at: string;
  name: string;
  accountId: number;
  pointOfSaleId: number;
  printDoubleOrder: boolean;
  preparation_time: number;
  street_address_1: string;
  street_address_2?: string;
  street_address_3?: string;
  city: string;
  zipcode: string;
  state: string;
  country: string;
  phone_number: string;
  account_name: string;
  subscription_id: string;
  billing: number;
  is_paused: boolean;
  cb_subscription_paused: boolean;
  unpaid_invoices: number;
  timezone: string;
  connected_delivery_services: string[];
}

export interface OrderoutRestaurantOnboardingType {
  account_name: string;
  restaurant_address_street: string;
  restaurant_address_city: string;
  restaurant_address_state: string;
  restaurant_address_zipcode: string;
  pos_uuid: string;
  account_manager_email: string;
  account_manager_firstname: string;
  account_manager_lastname: string;
  account_manager_phone: string;
  restaurant_manager_email: string;
  restaurant_manager_firstname: string;
  restaurant_manager_lastname: string;
  restaurant_manager_phone: string;
}

export interface ListOrderoutMenusType {
  id: number;
  name: string;
  api_created_at: string;
  published: boolean;
}

export interface OrderoutMenuPayloadType {
  name?: string;
  description?: string;
  items: OrderoutMenuItem[];
  menus: OrderoutMenus[];
  categories: OrderoutCategory[];
  modifier_groups: OrderoutModifierGroup[];
}

export interface OrderoutMenuItem {
  id: string;
  description?: Translatable;
  title: Translatable;
  image_url?: string;
  quantity_info?: QuantityInfo;
  external_data?: string;
  modifier_group_ids?: ModifierGroupIds;
  price_info: PriceInfo;
  tax_info: TaxInfo;
  visibility_info?: VisibilityInfo;
  suspension_info?: SuspensionInfo | null;
}

interface SuspensionInfo {
  suspension: { suspend_until: number; reason: string };
}

export interface VisibilityInfo {
  hours: VisibilityHours;
}

interface VisibilityHours {
  start_date?: string;
  end_date?: string;
  hours_of_week: ServiceAvailability[];
}

export interface Translatable {
  translations: {
    en_us: string;
    [key: string]: string;
  };
}

interface Quantity {
  max_permitted?: number;
  min_permitted?: number;
}

export interface QuantityInfo {
  overrides?: QuantityOverride[];
  quantity: Quantity;
}

interface QuantityOverride {
  context_type: string;
  context_value: string;
  quantity: Quantity;
}

interface ModifierGroupIds {
  ids: string[];
}

interface PriceInfo {
  price: number;
  overrides?: PriceOverride[];
}

interface PriceOverride {
  context_type: string;
  context_value: string;
  price: number;
}

interface TaxInfo {
  tax_rate: number;
}

export interface OrderoutMenus {
  service_availability: ServiceAvailability[];
  category_ids: string[];
  id: string;
  title: Translatable;
}

export type ServiceAvailabilityEntry = {
  day: string;
  startTime?: string;
  endTime?: string;
};

export type ServiceAvailabilityMap = {
  [dayOfWeek: string]: {
    start_time: string;
    end_time: string;
  }[];
};

interface ServiceAvailability {
  time_periods: TimePeriod[];
  day_of_week: string;
}

interface TimePeriod {
  start_time: string;
  end_time: string;
}

export interface OrderoutCategory {
  entities: CategoryEntity[];
  id: string;
  title: Translatable;
}

export interface CategoryEntity {
  type: string;
  id: string;
}

export interface OrderoutModifierGroup {
  quantity_info: QuantityDetails;
  title: Translatable;
  external_data?: string;
  modifier_options: ModifierOption[];
  display_type?: string | null;
  id: string;
}

interface QuantityDetails {
  quantity: {
    max_permitted?: number;
    min_permitted?: number;
  };
}

interface ModifierOption {
  type: string;
  id: string;
}
